// extracted by mini-css-extract-plugin
export default {"secondaryGrey500":"#6B7280","selectLabel":"custom_select_selectLabel__kd7Dw"};